// extracted by mini-css-extract-plugin
module.exports = {"asideNavContainer":"aside-nav-container-module--aside-nav-container--10cxj","rotated":"aside-nav-container-module--rotated--3ETwK"};